module.exports = __webpack_public_path__ + "static/media/green.00a9b1eb.JPG";